export const applyMateriauxFilters = (annonce, filters) => {
  const {
    typeMateriel = [],
    etat = [],
    prixMin,
    prixMax,
  } = filters;

  const isTypeMaterielFiltered =
    typeMateriel.length === 0 || typeMateriel.includes(annonce.typeMateriel);

  const isEtatFiltered =
    etat.length === 0 || etat.includes(annonce.etat);

  const isPrixFiltered =
    (!prixMin || annonce.prix >= prixMin) &&
    (!prixMax || annonce.prix <= prixMax);

  return isTypeMaterielFiltered && isEtatFiltered && isPrixFiltered;
};
